import { render, staticRenderFns } from "./EventosCredor.vue?vue&type=template&id=68bac524"
import script from "./EventosCredor.vue?vue&type=script&lang=js"
export * from "./EventosCredor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports